/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Status_Loading_Project_InfoInputs */



/**
* | output |
* | --- |
* | "Loading project info..." |
*
* @param {Work_Order_Import_Status_Loading_Project_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_status_loading_project_info = /** @type {((inputs?: Work_Order_Import_Status_Loading_Project_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Status_Loading_Project_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des informations du projet...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektinformationen werden geladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento informazioni sul progetto...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка информации о проекте...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando información del proyecto...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载项目信息...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト情報を読み込んでいます...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट की जानकारी लोड हो रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando informações do projeto...")
	return /** @type {LocalizedString} */ ("Loading project info...")
});